import { useEffect, useState } from 'react';

import { COOKIE_KEYS } from '../constants/cookie-keys';
import { BottomSheet } from '../ui/bottom-sheet';
import { Button } from '../ui/button';

export function NewVersionBottomSheet() {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    async function checkVersion() {
      const savedVersion = localStorage.getItem(COOKIE_KEYS.APP_VERSION);

      try {
        const response = await fetch(
          `https://listare-app.com.br/version.txt?t=${Date.now()}`,
          { cache: 'reload' },
        );

        if (!response.ok) {
          return;
        }

        const latestVersionWithTimestamp = await response.text();

        const latestVersion = latestVersionWithTimestamp.split('\n')[0].trim();

        if (savedVersion !== latestVersion) {
          console.log(
            `Versão atual: ${latestVersion}, versão salva: ${savedVersion}`,
          );

          if (savedVersion) {
            setShowUpdate(true);
          }

          localStorage.setItem(COOKIE_KEYS.APP_VERSION, latestVersion);
        }
      } catch (error) {
        console.error('Erro ao verificar a versão:', error);
      }
    }

    const handleVisibilityChange = async () => {
      // if (document.visibilityState === 'hidden') {}
      if (document.visibilityState === 'visible') {
        console.log('A aba está agora em foco, checando versão...');
        checkVersion();
      }
    };

    checkVersion();

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const reloadPage = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => reg.unregister());
      });
    }

    window.location.replace(window.location.href);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <BottomSheet
      open
      id="update-app-bottom-sheet"
      onClose={() => {}}
      title="Nova versão disponível!"
    >
      <div className="flex flex-col pb-4">
        <Button onClick={reloadPage}>Atualizar</Button>
      </div>
    </BottomSheet>
  );
}
